/**
 * Mobile Menu
 */

import { TweenMax, Power4, Expo, TimelineLite } from 'gsap';

// Élements & Variables
const html = document.querySelector('html');
const toggleBtn = document.querySelectorAll('.js-menu-toggle');
const menuContainer = document.querySelector('.js-fullscreen-menu');
const menuCloseBtn = menuContainer.querySelector('.js-menu-toggle');
const menuSplitBg = menuContainer.querySelectorAll('.fullscreen-menu__pane');
const menuListItems = menuContainer.querySelectorAll('.menu--main .menu-item');
const menuSocial = menuContainer.querySelectorAll('.social li');
const menuEventLogo = menuContainer.querySelectorAll('.fullscreen-menu__events .views-row');
const menuBackdrop = menuContainer.querySelectorAll('.fullscreen-menu__backdrop');

let navOpened = false;

const menuTimeLine = new TimelineLite({ paused: true });
menuTimeLine.add('start');
menuTimeLine.add( TweenMax.from(menuBackdrop, .8, {alpha:0, ease: Power4.easeInOut}), 'start' );
menuTimeLine.add( TweenMax.staggerFromTo(menuSplitBg, .8, {scaleX:0, ease: Power4.easeInOut}, {scaleX:1, ease: Expo.easeInOut}, .09), 'start+=0.15' );
menuTimeLine.add( TweenMax.staggerFromTo(menuListItems, .6, {y: 60, alpha:0, ease: Power4.easeOut}, {y:0, alpha:1, ease: Power4.easeOut}, .075), 'start+=0.5' );
menuTimeLine.add( TweenMax.staggerFromTo(menuSocial, .5, {y: 60, alpha:0, ease: Power4.easeOut}, {y:0, alpha:1, ease: Power4.easeOut}, .05), 'start+=0.7' );
menuTimeLine.add( TweenMax.staggerFromTo(menuEventLogo, .6, {y: 40, alpha:0, ease: Power4.easeOut}, {y:0, alpha:1, ease: Power4.easeOut}, .09), 'start+=0.8' );
menuTimeLine.add( TweenMax.fromTo(menuCloseBtn, 0.8, {y: 20, alpha:0, ease: Power4.easeInOut}, {y:0, alpha:1, ease: Power4.easeOut}), 'start+=.8' );

// Au click sur le bouton
if (toggleBtn.length) {
  toggleBtn.forEach((btn) => {
    btn.addEventListener('click', (ev) => {
      ev.preventDefault();

      if(navOpened) {
        navOpened = false;
        html.classList.remove('menu-open');
        menuTimeLine.timeScale(1.6);
        menuTimeLine.reverse();
      } else {
        navOpened = true;
        html.classList.add('menu-open');
        menuTimeLine.timeScale(1.1);
        menuTimeLine.play();
      }
    });
  });
}
